import React from 'react';
import { INBOUND_ROLES } from 'utils/constants';
import { ENUM_INBOUND_ROLE } from 'utils/enum';

export type Props = {
  type: ENUM_INBOUND_ROLE;
};

const RoleTag = ({ type }: Props) => {
  const { bgColor, borderColor, text, textColor } = INBOUND_ROLES[type];
  return (
    <span
      style={{
        backgroundColor: bgColor,
        borderColor: borderColor,
        color: textColor
      }}
      className={`border-[1px] rounded-[5px] text-xs leading-[19px] px-4 py-1`}>
      {text}
    </span>
  );
};
export default RoleTag;
